export default "__VITE_ASSET__CtR3DhzJ__"